// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "create_credit_note_token": {
      "column": {
        "default": null,
        "name": "create_credit_note_token",
        "null": true,
        "type": "string"
      },
      "name": "create_credit_note_token",
      "selected_by_default": null,
      "translated": null
    },
    "credit_sales_order_line_token": {
      "column": {
        "default": null,
        "name": "credit_sales_order_line_token",
        "null": true,
        "type": "string"
      },
      "name": "credit_sales_order_line_token",
      "selected_by_default": null,
      "translated": null
    },
    "create_sales_order_token": {
      "column": {
        "default": null,
        "name": "create_sales_order_token",
        "null": true,
        "type": "string"
      },
      "name": "create_sales_order_token",
      "selected_by_default": null,
      "translated": null
    },
    "create_vendor_bank_account_token": {
      "column": {
        "default": null,
        "name": "create_vendor_bank_account_token",
        "null": true,
        "type": "string"
      },
      "name": "create_vendor_bank_account_token",
      "selected_by_default": null,
      "translated": null
    },
    "create_vendor_token": {
      "column": {
        "default": null,
        "name": "create_vendor_token",
        "null": true,
        "type": "string"
      },
      "name": "create_vendor_token",
      "selected_by_default": null,
      "translated": null
    },
    "dummy_account_no_for_outlay_cards": {
      "column": {
        "default": null,
        "name": "dummy_account_no_for_outlay_cards",
        "null": true,
        "type": "integer"
      },
      "name": "dummy_account_no_for_outlay_cards",
      "selected_by_default": null,
      "translated": null
    },
    "domain": {
      "column": {
        "default": null,
        "name": "domain",
        "null": true,
        "type": "string"
      },
      "name": "domain",
      "selected_by_default": null,
      "translated": null
    },
    "get_customer_ledger_entries_token": {
      "column": {
        "default": null,
        "name": "get_customer_ledger_entries_token",
        "null": true,
        "type": "string"
      },
      "name": "get_customer_ledger_entries_token",
      "selected_by_default": null,
      "translated": null
    },
    "get_customer_token": {
      "column": {
        "default": null,
        "name": "get_customer_token",
        "null": true,
        "type": "string"
      },
      "name": "get_customer_token",
      "selected_by_default": null,
      "translated": null
    },
    "get_dimension_value_token": {
      "column": {
        "default": null,
        "name": "get_dimension_value_token",
        "null": true,
        "type": "string"
      },
      "name": "get_dimension_value_token",
      "selected_by_default": null,
      "translated": null
    },
    "get_gl_account_token": {
      "column": {
        "default": null,
        "name": "get_gl_account_token",
        "null": true,
        "type": "string"
      },
      "name": "get_gl_account_token",
      "selected_by_default": null,
      "translated": null
    },
    "get_item_token": {
      "column": {
        "default": null,
        "name": "get_item_token",
        "null": true,
        "type": "string"
      },
      "name": "get_item_token",
      "selected_by_default": null,
      "translated": null
    },
    "get_smart_bank_account_entries_token": {
      "column": {
        "default": null,
        "name": "get_smart_bank_account_entries_token",
        "null": true,
        "type": "string"
      },
      "name": "get_smart_bank_account_entries_token",
      "selected_by_default": null,
      "translated": null
    },
    "get_vendor_token": {
      "column": {
        "default": null,
        "name": "get_vendor_token",
        "null": true,
        "type": "string"
      },
      "name": "get_vendor_token",
      "selected_by_default": null,
      "translated": null
    },
    "gl_entries_post_token": {
      "column": {
        "default": null,
        "name": "gl_entries_post_token",
        "null": true,
        "type": "string"
      },
      "name": "gl_entries_post_token",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "post_general_journal_token": {
      "column": {
        "default": null,
        "name": "post_general_journal_token",
        "null": true,
        "type": "string"
      },
      "name": "post_general_journal_token",
      "selected_by_default": null,
      "translated": null
    },
    "post_sales_doc_token": {
      "column": {
        "default": null,
        "name": "post_sales_doc_token",
        "null": true,
        "type": "string"
      },
      "name": "post_sales_doc_token",
      "selected_by_default": null,
      "translated": null
    },
    "upsert_customer_token": {
      "column": {
        "default": null,
        "name": "upsert_customer_token",
        "null": true,
        "type": "string"
      },
      "name": "upsert_customer_token",
      "selected_by_default": null,
      "translated": null
    },
    "get_sales_invoices_token": {
      "column": {
        "default": null,
        "name": "get_sales_invoices_token",
        "null": true,
        "type": "string"
      },
      "name": "get_sales_invoices_token",
      "selected_by_default": null,
      "translated": null
    },
    "get_sales_credit_notes_token": {
      "column": {
        "default": null,
        "name": "get_sales_credit_notes_token",
        "null": true,
        "type": "string"
      },
      "name": "get_sales_credit_notes_token",
      "selected_by_default": null,
      "translated": null
    },
    "get_gl_entry_token": {
      "column": {
        "default": null,
        "name": "get_gl_entry_token",
        "null": true,
        "type": "string"
      },
      "name": "get_gl_entry_token",
      "selected_by_default": null,
      "translated": null
    },
    "path": {
      "column": {
        "default": null,
        "name": "path",
        "null": true,
        "type": "string"
      },
      "name": "path",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "TenantInventioSetting",
  "collectionKey": "tenant_inventio_settings",
  "collectionName": "tenant_inventio_settings",
  "i18nKey": "tenant_inventio_setting",
  "camelizedLower": "tenantInventioSetting",
  "name": "TenantInventioSetting",
  "nameDasherized": "tenant-inventio-setting",
  "pluralName": "tenant_inventio_settings",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "create_credit_note_token",
      "column": {
        "default": null,
        "name": "create_credit_note_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "create_sales_order_token",
      "column": {
        "default": null,
        "name": "create_sales_order_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "create_vendor_bank_account_token",
      "column": {
        "default": null,
        "name": "create_vendor_bank_account_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "create_vendor_token",
      "column": {
        "default": null,
        "name": "create_vendor_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "credit_sales_order_line_token",
      "column": {
        "default": null,
        "name": "credit_sales_order_line_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "debtor_account_number_prefix",
      "column": {
        "default": "DN",
        "name": "debtor_account_number_prefix",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "domain",
      "column": {
        "default": null,
        "name": "domain",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "dummy_account_no_for_outlay_cards",
      "column": {
        "default": null,
        "name": "dummy_account_no_for_outlay_cards",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "get_customer_ledger_entries_token",
      "column": {
        "default": null,
        "name": "get_customer_ledger_entries_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "get_customer_token",
      "column": {
        "default": null,
        "name": "get_customer_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "get_dimension_value_token",
      "column": {
        "default": null,
        "name": "get_dimension_value_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "get_gl_account_token",
      "column": {
        "default": null,
        "name": "get_gl_account_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "get_gl_entry_token",
      "column": {
        "default": null,
        "name": "get_gl_entry_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "get_item_token",
      "column": {
        "default": null,
        "name": "get_item_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "get_sales_credit_notes_token",
      "column": {
        "default": null,
        "name": "get_sales_credit_notes_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "get_sales_invoices_token",
      "column": {
        "default": null,
        "name": "get_sales_invoices_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "get_smart_bank_account_entries_token",
      "column": {
        "default": null,
        "name": "get_smart_bank_account_entries_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "get_vendor_token",
      "column": {
        "default": null,
        "name": "get_vendor_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "gl_entries_post_token",
      "column": {
        "default": null,
        "name": "gl_entries_post_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "path",
      "column": {
        "default": null,
        "name": "path",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "post_general_journal_token",
      "column": {
        "default": null,
        "name": "post_general_journal_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "post_sales_doc_token",
      "column": {
        "default": null,
        "name": "post_sales_doc_token",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "upsert_customer_token",
      "column": {
        "default": null,
        "name": "upsert_customer_token",
        "null": true,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "tenant_inventio_setting",
  "primaryKey": "id"
}

/** Frontend model for TenantInventioSetting. */
export default class TenantInventioSetting extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  createCreditNoteToken() {
    return this.readAttributeUnderscore("create_credit_note_token")
  }

  /** @returns {boolean} */
  hasCreateCreditNoteToken() {
    const value = this.createCreditNoteToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  creditSalesOrderLineToken() {
    return this.readAttributeUnderscore("credit_sales_order_line_token")
  }

  /** @returns {boolean} */
  hasCreditSalesOrderLineToken() {
    const value = this.creditSalesOrderLineToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  createSalesOrderToken() {
    return this.readAttributeUnderscore("create_sales_order_token")
  }

  /** @returns {boolean} */
  hasCreateSalesOrderToken() {
    const value = this.createSalesOrderToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  createVendorBankAccountToken() {
    return this.readAttributeUnderscore("create_vendor_bank_account_token")
  }

  /** @returns {boolean} */
  hasCreateVendorBankAccountToken() {
    const value = this.createVendorBankAccountToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  createVendorToken() {
    return this.readAttributeUnderscore("create_vendor_token")
  }

  /** @returns {boolean} */
  hasCreateVendorToken() {
    const value = this.createVendorToken()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  dummyAccountNoForOutlayCards() {
    return this.readAttributeUnderscore("dummy_account_no_for_outlay_cards")
  }

  /** @returns {boolean} */
  hasDummyAccountNoForOutlayCards() {
    const value = this.dummyAccountNoForOutlayCards()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  domain() {
    return this.readAttributeUnderscore("domain")
  }

  /** @returns {boolean} */
  hasDomain() {
    const value = this.domain()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  getCustomerLedgerEntriesToken() {
    return this.readAttributeUnderscore("get_customer_ledger_entries_token")
  }

  /** @returns {boolean} */
  hasGetCustomerLedgerEntriesToken() {
    const value = this.getCustomerLedgerEntriesToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  getCustomerToken() {
    return this.readAttributeUnderscore("get_customer_token")
  }

  /** @returns {boolean} */
  hasGetCustomerToken() {
    const value = this.getCustomerToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  getDimensionValueToken() {
    return this.readAttributeUnderscore("get_dimension_value_token")
  }

  /** @returns {boolean} */
  hasGetDimensionValueToken() {
    const value = this.getDimensionValueToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  getGlAccountToken() {
    return this.readAttributeUnderscore("get_gl_account_token")
  }

  /** @returns {boolean} */
  hasGetGlAccountToken() {
    const value = this.getGlAccountToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  getItemToken() {
    return this.readAttributeUnderscore("get_item_token")
  }

  /** @returns {boolean} */
  hasGetItemToken() {
    const value = this.getItemToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  getSmartBankAccountEntriesToken() {
    return this.readAttributeUnderscore("get_smart_bank_account_entries_token")
  }

  /** @returns {boolean} */
  hasGetSmartBankAccountEntriesToken() {
    const value = this.getSmartBankAccountEntriesToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  getVendorToken() {
    return this.readAttributeUnderscore("get_vendor_token")
  }

  /** @returns {boolean} */
  hasGetVendorToken() {
    const value = this.getVendorToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  glEntriesPostToken() {
    return this.readAttributeUnderscore("gl_entries_post_token")
  }

  /** @returns {boolean} */
  hasGlEntriesPostToken() {
    const value = this.glEntriesPostToken()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  postGeneralJournalToken() {
    return this.readAttributeUnderscore("post_general_journal_token")
  }

  /** @returns {boolean} */
  hasPostGeneralJournalToken() {
    const value = this.postGeneralJournalToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  postSalesDocToken() {
    return this.readAttributeUnderscore("post_sales_doc_token")
  }

  /** @returns {boolean} */
  hasPostSalesDocToken() {
    const value = this.postSalesDocToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  upsertCustomerToken() {
    return this.readAttributeUnderscore("upsert_customer_token")
  }

  /** @returns {boolean} */
  hasUpsertCustomerToken() {
    const value = this.upsertCustomerToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  getSalesInvoicesToken() {
    return this.readAttributeUnderscore("get_sales_invoices_token")
  }

  /** @returns {boolean} */
  hasGetSalesInvoicesToken() {
    const value = this.getSalesInvoicesToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  getSalesCreditNotesToken() {
    return this.readAttributeUnderscore("get_sales_credit_notes_token")
  }

  /** @returns {boolean} */
  hasGetSalesCreditNotesToken() {
    const value = this.getSalesCreditNotesToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  getGlEntryToken() {
    return this.readAttributeUnderscore("get_gl_entry_token")
  }

  /** @returns {boolean} */
  hasGetGlEntryToken() {
    const value = this.getGlEntryToken()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  path() {
    return this.readAttributeUnderscore("path")
  }

  /** @returns {boolean} */
  hasPath() {
    const value = this.path()

    return this._isPresent(value)
  }
}
